const SCRIPT_SRC =
  "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

let scriptPromise = null;

function waitForTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(
      () => reject(new Error("Turnstile load timeout")),
      15000
    );
    const timer = setInterval(() => {
      if (window.turnstile) {
        clearInterval(timer);
        clearTimeout(timeout);
        resolve(window.turnstile);
      }
    }, 50);
  });
}

export function loadTurnstileScript() {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Turnstile unavailable"));
  }
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(
      'script[src*="challenges.cloudflare.com/turnstile"]'
    );
    if (existing) {
      waitForTurnstile().then(resolve).catch(reject);
      return;
    }

    const script = document.createElement("script");
    script.src = SCRIPT_SRC;
    // 不使用 async/defer，避免与 turnstile.ready() 冲突；此处直接等 onload
    script.onload = () => resolve(window.turnstile);
    script.onerror = () => {
      scriptPromise = null;
      reject(new Error("Failed to load Turnstile"));
    };
    document.head.appendChild(script);
  });

  return scriptPromise;
}

export function whenTurnstileReady() {
  return loadTurnstileScript();
}

export function renderTurnstile(container, options) {
  if (!window.turnstile || !container) return null;
  container.innerHTML = "";
  return window.turnstile.render(container, options);
}

export function executeTurnstile(widgetId) {
  if (widgetId != null && window.turnstile) {
    window.turnstile.execute(widgetId);
  }
}

export function resetTurnstile(widgetId) {
  if (widgetId != null && window.turnstile) {
    window.turnstile.reset(widgetId);
  }
}

export function removeTurnstile(widgetId) {
  if (widgetId != null && window.turnstile) {
    window.turnstile.remove(widgetId);
  }
}

export function getTurnstileLanguage(locale) {
  const map = {
    zh: "zh-cn",
    hk: "zh-tw",
    en: "en",
    ko: "ko",
    ja: "ja",
  };
  return map[locale] || "auto";
}
